export default __webpack_public_path__ + "static/media/ic-playlist-video.67197e95.svg";